import React from 'react'
import "./style.css"

const Progressbar = ({ reviewDistribution = {} }) => {
    console.log(reviewDistribution)
    const progressData = [
        { id: 5, label: "Perfection", value: reviewDistribution["5"] || 0 },
        { id: 4, label: "Great", value: reviewDistribution["4"] || 0 },
        { id: 3, label: "Good", value: reviewDistribution["3"] || 0 },
        { id: 2, label: "Ok", value: reviewDistribution["2"] || 0 },
        { id: 1, label: "Awful", value: reviewDistribution["1"] || 0 },
    ];
  return (
    <div>
       <div className='review_submission_box px-5 py-3'>
                            <h4 className='review_distribution_h4 mb-3'>Review Distribution</h4>
                            {progressData.map((progress) => (
                                <div key={progress.id} className='d-flex align-items-center mb-3'>
                                    <div className='min_width_progress_label text-end'>
                                        <span className='progress_label_span pe-2'>
                                            {progress.label} <span className='progress_label_id'>{progress.id}</span>
                                        </span>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            height: "30px",
                                            backgroundColor: "#ECECEC",
                                            overflow: "hidden",
                                            position: "relative",
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: `${progress.value}%`,
                                                height: "100%",
                                                backgroundColor: "#0A00D1",
                                                transition: "width 0.5s ease-in-out",
                                            }}
                                        ></div>
                                    </div>
                                    <div>
                                        <span className='progress_value_span ps-2'>
                                            {progress.value}%
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
    </div>
  )
}

export default Progressbar
